/**
 * 展会列表 Island 为 SSR 静态 HTML，确认翻页按钮需在客户端用事件委托处理。
 * 见 Pagination `.btn-jump[data-fair-pager-jump]` 上的 data-* 属性。
 */
import { fairSemanticListPathWithTrailingSlash } from '~/utils/fairSemanticListing'

function buildFairListPagerHref(prefixRaw: string, page: number, querySuffix: string): string {
  const pg = Math.max(1, Math.floor(page) || 1)
  let base = (prefixRaw || '').trim().replace(/\/p-\d+\/?$/i, '').replace(/\/+$/, '')
  if (!base) {
    base = (typeof location !== 'undefined' ? location.pathname : '/all')
      .replace(/\/p-\d+\/?$/i, '')
      .replace(/\/+$/, '') || '/all'
  }
  const path = pg <= 1 ? base : `${base}/p-${pg}`
  const q =
    querySuffix ||
    (typeof location !== 'undefined' && location.search ? location.search : '')
  return fairSemanticListPathWithTrailingSlash(`${path}${q}`)
}

function handleFairListPagerJump(e: Event) {
  const target = e.target
  if (!(target instanceof Element)) return
  const btn = target.closest('a.btn-jump[data-fair-pager-jump]')
  if (!(btn instanceof HTMLAnchorElement)) return

  e.preventDefault()

  const jumpBox = btn.previousElementSibling
  const input = jumpBox?.querySelector('.jump-input')
  const maxPage = Math.max(1, parseInt(btn.getAttribute('data-max-page') || '1', 10) || 1)
  let page = parseInt(String((input as HTMLInputElement | null)?.value ?? ''), 10) || 1
  page = Math.max(1, Math.min(maxPage, page))

  const prefix = btn.getAttribute('data-semantic-page-prefix') || ''
  const querySuffix = btn.getAttribute('data-query-suffix') || ''
  window.location.href = buildFairListPagerHref(prefix, page, querySuffix)
}

function handleFairListPagerEnter(e: Event) {
  if (!(e instanceof KeyboardEvent) || e.key !== 'Enter') return
  const target = e.target
  if (!(target instanceof HTMLInputElement) || !target.classList.contains('jump-input')) return
  const jumpBox = target.closest('.pager-jump')
  const btn = jumpBox?.nextElementSibling
  if (!(btn instanceof HTMLAnchorElement) || !btn.matches('.btn-jump[data-fair-pager-jump]')) return
  e.preventDefault()
  btn.click()
}

export default defineNuxtPlugin(() => {
  document.addEventListener('click', handleFairListPagerJump, true)
  document.addEventListener('keydown', handleFairListPagerEnter, true)
})
